<template>
  <div v-if="filteredCameras.length >= 1">
    <div
      class="category-container"
      @click="collapsed=!collapsed"
    >
      <div class="owal camera list header">
        {{ category }}
        <i
          v-if="!collapsed"
          class="chevron down small icon"
        />
        <i
          v-else
          class="chevron right small icon"
        />
      </div>
    </div>
    <div
      v-for="camera in filteredCameras"
      v-show="!collapsed"
      :key="camera.uuid"
    >
      <div
        class="camera-card"
        @click="selectCamera(camera.uuid)"
      >
        {{ camera.description }}
      </div>
    </div>
  </div>
</template>

<script>
import { sortCameras } from '@/libraries/util/normalizeData'

export default {
  name: 'CameraList',
  props: ['category', 'cameras'],
  data: function () {
    return {
      collapsed: false,
    }
  },
  computed: {
    filteredCameras: function () {
      let results = sortCameras(this.cameras.filter(camera => camera.category === this.category))
      return results
    },
  },
  methods: {
    selectCamera: function (cameraId) {
      this.$emit('change', cameraId)
    },
  },
}
</script>

<style scoped>
.category-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 44px;
  background: #475669;
  font-family: "Avenir-Black";
  color: #C0CCDA;
  letter-spacing: 0;
}

.owal.camera.list.header {
  margin: 0;
  height : 2.75rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 0.93rem;
  padding-right: 1.95rem;
}

.camera-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .25rem 0 0 .5rem;
  cursor: pointer;
  margin-right: .75rem;
  height: 44px;
}

.camera-card:hover {
  font-weight: bold;
  background-color: rgba(188, 188, 188, 0.2);
}

#category {
  padding-top: .5rem;
}
</style>
